import http from "../../http";

/** 本地推送任务 — /resident/api/resident/housePushJob */
const BASE = "/resident/api/resident/housePushJob";

const pushJob = {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  selectById(r) {
    return http.get(`${BASE}/detail`, r);
  },
  recordPage(r) {
    return http.get(`${BASE}/recordPage`, r);
  },
};

export default pushJob;
